<span class="cmdk-row__icon" aria-hidden="true">
  @if (item().newsType === 'spotlight') {
    <paper-spotlight-mark [size]="20" data-testid="emp.spotlight.places.search.mark" />
  } @else {
    <paper-icon [name]="icon()" [size]="20" />
  }
</span>

<span class="cmdk-row__text">
  <span class="cmdk-row__title">{{ item().title }}</span>
  @if (item().subtitle) {
    <span class="cmdk-row__subtitle">{{ item().subtitle }}</span>
  }
</span>

@if (quickOpenKey(); as digit) {
  <paper-kbd class="cmdk-row__quick" [keys]="digit" [mod]="true" size="sm" />
}
